import { onBeforeUnmount } from 'vue';
import { app } from '@ibgroup-tws-webapps/ratio.ui';

/**
 * Centralizes the host-bridge actions every module entry point shares
 * (`AppShell`, `ProductDetailsModule`, `ElectionHubModule`, ...).
 *
 * Currently handles "exit on back": forwards two host messages as
 * `back { exit: true }`:
 *   - `back` — software back button
 *   - `native_header_action` with `COD === 'NATIVE_BACK'` — native chrome back
 *
 * Auto-unsubscribes on unmount.
 *
 * @param onBack Optional pre-action hook (e.g. unsubscribe streams) run BEFORE
 *   forwarding the back signal to the host.
 */
export function useCommonNativeActions(onBack?: () => void): void {
  const bridge = app.getBridge();
  const unsubscribe = bridge?.onMessage((msg) => {
    if (msg.action === 'back') {
      onBack?.();
      app.send({ action: 'back', data: { exit: true } });
      return;
    }
    if (msg.action === 'native_header_action') {
      const data = msg.data as { COD?: string } | undefined;
      if (data?.COD === 'NATIVE_BACK') {
        onBack?.();
        app.send({ action: 'back', data: { exit: true } });
      }
    }
  });

  onBeforeUnmount(() => {
    unsubscribe?.();
  });
}
